import sanitizeHtml from 'sanitize-html'

/**
 * Sanitization rules for internal system notices
 * Allows basic formatting and anchor tags for internal/external links
 */
const SANITIZE_OPTIONS = {
	allowedTags: ['a', 'b', 'strong', 'i', 'em', 'br', 'p'],
	allowedAttributes: {
		a: ['href', 'target', 'rel'],
		p: ['class']
	},
	allowedSchemes: ['https', 'http', 'mailto', 'tel'], // Added 'tel' for phone links
	transformTags: {
		a: (tagName: string, attribs: Record<string, string>) => {
			const href = (attribs.href || '').trim()

			// Validate URL format - allow https, http, mailto, and tel
			if (!href.match(/^(https?:\/\/|mailto:|tel:)/i)) {
				// Convert invalid links to plain text
				// Return text content only, not a span tag
				return {
					tagName: false, // This removes the tag but keeps content
					text: attribs.href || ''
				}
			}

			// Add security attributes for external links
			return {
				tagName: 'a',
				attribs: {
					href: href,
					target: attribs.target || '_blank',
					rel: 'noopener noreferrer'
				}
			}
		}
	}
} as const

export function sanitizeContent(html: string) {
	return sanitizeHtml(html, SANITIZE_OPTIONS)
}
